import { Routes } from '@angular/router';

import { AppLayout } from './layouts/app-layout';
import { AuthLayout } from './layouts/auth-layout';
import { adminSessionGuard } from './core/guards/admin-session.guard';
import { PAGE_ROUTES } from './pages/pages.route';

export const routes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [adminSessionGuard],
        children: PAGE_ROUTES,
    },
    // {
    //     path: 'timesheet',
    //     component: AppLayout,
    //     loadChildren: () => import('./timesheet/timesheet.route').then(m => m.TimesheetRouting)
    // },
    // {
    //     path: 'travel',
    //     component: AppLayout,
    //     loadChildren: () => import('./travel-portal/travel.route').then(m => m.TravelRouting)
    // },
    {
        path: 'aadhaar-digilocker-done',
        loadComponent: () =>
            import('./pages/manage-agent/create-agent/simulate-agent/screens/aadhaar/aadhaar-digilocker-done.component').then(
                (m) => m.AadhaarDigilockerDoneComponent,
            ),
    },
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
        // children: [
        //     // Define child routes for AuthLayout here if any
        // ],
    },
];
